<template>
  <div>
    <h2>TEST</h2>
    <bend-plan-row
        v-for="(aBend, j) in userDataBends"
        :bend="aBend"
        :resource="resource"
        :key="`bpr-${j}`"
    />
    <form-side-bar
      :sb-id="formSBId"
      :sb-model="formSBModel"
      :resource="resource"
      :settings="settings"
      @med-form-click="handleSaveMed"
      @close-clicked="handleCloseFormSideBar"
    />
    <resource-nav-bar
        v-if="resource"
        :resource="resource"
        @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <b-button
            v-if="false"
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenContactsSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone" aria-hidden="true" />
        </b-button>
        <b-button
            v-if="false"
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenAddContactSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone-plus" aria-hidden="true" />
        </b-button>
        <b-button
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenFormSideBar"
        >
          <b-icon icon="clipboard-plus" aria-hidden="true" />
        </b-button>
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import MedCard from "./medCard";
import FormSideBar from "./formSideBar";
import LogTableView from "./slideView/logTableView";
import BendPlanRow from '../../_components/bendPlanRow';
export default {
  name: "Display_Bend",
  mixins: [ResourceBlockDisplay],
  components: {
    MedCard,
    ResourceNavBar,
    FormSideBar,
    LogTableView,
    BendPlanRow
  },
  props: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    /* SETTINGS */
    /* USER DATA */
    userDataBends() {
      return this.userData &&
      this.userData &&
      this.userData[`app_${this.resource.toolId}`] &&
      this.userData[`app_${this.resource.toolId}`].bends
          ? this.userData[`app_${this.resource.toolId}`].bends
          : [];
    }
  },
  methods: {
    handleSaveMed(form) {
      debugger;
      let meds = {
        meds: [form]
      };

      let notif = {
        //create message
        title: `Medication Saved`,
        description: "Congrats you have updated your Medication List",
        variant: "success"
      };

      const payload = {
        userData: meds,
        notif: notif,
        key: "meds"
      };

      this.handleUpdateUserData(payload);
    },
    handleSaveContact(contact) {
      let logs = {
        contacts: [contact]
      };

      //list wgo the contact is for
      let contactName = contact.isCompany ? contact.company ?  contact.company :''
          : contact.firstname;
      let notif = {
        title: `Contact Save`,
        description: `You have saved the contact for ${contactName}.`,
        variant: "success"
      };

      const payload = {
        userData: logs,
        notif: notif,
        key: "contacts"
      };

      this.handleUpdateUserData(payload);
    },
    /** LOG FORM **/
    handleOpenFormSideBar() {
      this.formSBModel = true;
    },
    handleCloseFormSideBar() {
      this.formSBModel = false;
    },
    /** CONTACTS **/
    handleOpenContactsSideBar() {
      this.contactsSBModel = true;
    },
    handleCloseContactsSideBar() {
      this.contactsSBModel = false;
    },
    /** Add/+ CONTACT **/
    handleOpenAddContactSideBar() {
      this.addContactSBModel = true;
    },
    handleCloseAddContactSideBar() {
      this.addContactSBModel = false;
    },
    handleGoBack() {
      this.$refs[this.slideRefId].handleGoBack();
    }
  },
  data() {
    return {
      slideRefId: "slide-view",
      assetsURLHome: "/assets/apps/calllog/",
      audioDuration: null,
      formSBId: "form-sidebar",
      formSBModel: false,
      contactsSBId: "contacts-sidebar",
      contactsSBModel: false,
      addContactSBId: "add-contact-sidebar",
      addContactSBModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
